import { render, staticRenderFns } from "./upsert-group.vue?vue&type=template&id=4f24876b&scoped=true"
import script from "./upsert-group.vue?vue&type=script&lang=js"
export * from "./upsert-group.vue?vue&type=script&lang=js"
import style0 from "./upsert-group.vue?vue&type=style&index=0&id=4f24876b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f24876b",
  null
  
)

export default component.exports